import React, { createContext, useState } from 'react';
import '../assets/themeColor.css'

export const ThemeContext = createContext();

const ThemeContextProvider= (props)=>{


    const userPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    const userPrefersLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
    
    if(userPrefersDark){
        console.log("User prefers a dark interface");
    }
    if(userPrefersLight){
        console.log("User prefers a light interface");
    }




    const [theme,setTheme]=useState("light");
    const handleThemeChange=()=>{
       if(theme==="dark"){
           setTheme("light")
       }
       if(theme==="light"){
           setTheme("dark")
       }
    }
    return(
        <ThemeContext.Provider  value={{theme,handleThemeChange}}>
            <div className={theme}>
               {props.children}</div>
        </ThemeContext.Provider>
    )
}

export default ThemeContextProvider;